<template>
  <v-flex
    xs12
  >
    <h3>Tracking</h3>
    <v-divider></v-divider>
    <h3 class="pt-3">URL Parameters <small>(optional)</small></h3>
    <v-flex
      xs12
      sm5
      md5
    >
      <v-text-field
        prepend-icon="link"
        placeholder="Ex: key1=value1&key2=value2"
        v-model="urlParams"
        @change="setUrlParams"
      ></v-text-field>
    </v-flex>
    <v-flex
      xs12
      sm5
      md5
    >
      <h3>Conversion Tracking</h3>
    </v-flex>
    <v-flex
      xs12
      sm5
      md5
      class="py-3 relative"
    >
      <v-switch
        v-model="facebookPixelsActive"
        label="Facebook Pixel"
        color="primary"
        hide-details
      ></v-switch>

      <v-card
        text
        color="grey lighten-4"
        v-if="facebookPixelsActive"
      >
        <v-card-text
          v-if="pixels && selectedPixel"
          @click="switchDropdown"
        >
          <v-layout
            row
            justify-space-between
            align-center
            >
            <strong>
              <span class="green-circle mr-2"></span>
              {{ selectedPixel.name }}
            </strong>
            <i
              class="v-icon material-icons pointer grey--text"
              v-if="!dropdown"
            >
              keyboard_arrow_down
            </i>
            <i
              class="v-icon material-icons pointer grey--text"
              v-else
            >
              keyboard_arrow_up
            </i>
          </v-layout>
          <span class="grey--text pl-3">ID:{{ selectedPixel.id }}</span>
        </v-card-text>
        <v-card-text
          v-else
          @click="switchDropdown"
        >
        <v-icon color="primary" medium>info</v-icon>
          <p>There are <b>no tracking pixels</b> registered for this account.  Please create a pixel in the Facebook UI. <a href="https://www.facebook.com/business/help/952192354843755">Read here about how to do so.</a></p>
          <p>A <b>tracking pixel</b> allows you to measure how many of the people who viewed your ads then read your website or donated to your campaign online. This gives you a good measure for how effective one ad is relative to another.</p>
        </v-card-text>
      </v-card>

      <v-card
        class="my-1 absolute dropdown-card"
        v-if="dropdown"
      >
        <v-card-text
          v-for="pixel in pixels"
          :key="pixel.id"
          @click="selectPixel(pixel)"
        >
          <span class="green-circle"></span>
          <strong class="pl-1">{{ pixel.name }}</strong><br>
          <span class="grey--text pl-3">ID:{{ pixel.id }}</span>
        </v-card-text>

      </v-card>

    </v-flex>

    <h3 class="pt-3">Political</h3>
    <v-flex
      d-flex
      align-center
      xs12
      sm5
      md5
    >
      <v-checkbox
        v-model="ad_political"
        hide-details
        class="mt-0"
      ></v-checkbox>
      <div>This ad relates to politics, or an issue of national importance. <a href='https://www.facebook.com/business/help/1838453822893854'>Learn more</a></div>
    </v-flex>

    <h3 class="pt-3">Ad name</h3>
    <v-flex
      xs12
      sm5
      md5
    >
      <v-text-field
        prepend-icon="edit"
        :value="name"
        @input="setName"
      ></v-text-field>
    </v-flex>
  </v-flex>
</template>

<script>
export default {
  name: 'upload-image-tracking-block',
  data () {
    return {
      ad_political: true,
      facebookPixelsActive: true,
      selectedPixel: {},
      messageName: 'Your message name',
      dropdown: false,
      urlParams: ''
    }
  },
  props: {
    name: {
      type: String,
      default: 'My message name'
    }
  },
  mounted () {
    if (this.pixels) this.selectedPixel = this.pixels[0]
  },
  computed: {
    pixels () {
      if (!this.$store.getters.getCurrentUser.pixels) return false
      return this.$store.getters.getCurrentUser.pixels
    }
  },
  methods: {
    switchDropdown () {
      this.dropdown = !this.dropdown
    },
    selectPixel (pixel) {
      this.dropdown = false
      this.selectedPixel = pixel
    },
    setName (value) {
      this.$emit('setMessageFields', value, 'name')
    },
     setUrlParams (value) {
       this.$emit('setMessageFields', value, 'urlParams')
     }
  },
  watch: {
    pixels (val) {
      if (val) this.selectedPixel = val[0]
    },
    selectedPixel (val) {
      this.$emit('setMessageFields', val.id, 'selectedPixel')
    },
    ad_political (val) {
      this.$emit('setMessageFields', val, 'political', true)
    }
  }
}
</script>
<style>
  .relative {
    position: relative;
  }
  .absolute {
    position: absolute;
  }
  .dropdown-card{
    width: 100%;
    height: auto;
    max-height: 213px;
    overflow: auto;
    z-index: 99;
  }
  .dropdown-card .card__text:not(last-child) {
    border-bottom: 1px solid rgba(0,0,0,.1);
  }
</style>
